import { render, staticRenderFns } from "./UserPriceItemEx.vue?vue&type=template&id=8ac7c282&scoped=true&"
import script from "./UserPriceItemEx.vue?vue&type=script&lang=js&"
export * from "./UserPriceItemEx.vue?vue&type=script&lang=js&"
import style0 from "./UserPriceItemEx.vue?vue&type=style&index=0&id=8ac7c282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac7c282",
  null
  
)

export default component.exports